import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
var COUNT_MOBILE_PAGES = 5;
export var getPages = function getPages(current, total, isMobile) {
  /** render items if total <=5 */
  if (total <= COUNT_MOBILE_PAGES) {
    return Array.from({
      length: total
    }, function (_, index) {
      return {
        value: index + 1
      };
    });
  }
  if (isMobile) {
    /** render first items */
    if (current <= 3) {
      return Array.from({
        length: COUNT_MOBILE_PAGES
      }, function (_, index) {
        return {
          value: index + 1
        };
      });
    }
    /** render last items */
    if (current + 2 >= total) {
      return Array.from({
        length: COUNT_MOBILE_PAGES
      }, function (_, index) {
        return {
          value: total - index
        };
      }).reverse();
    }
    /** render middle items */
    if (current > 3) {
      return Array.from({
        length: COUNT_MOBILE_PAGES
      }, function (_, index) {
        return {
          value: current - 2 + index
        };
      });
    }
  }
  return [].concat(_toConsumableArray(current > 2 ? [{
    value: 1
  }] : []), _toConsumableArray(current > 3 ? [{
    isDots: true,
    value: '...'
  }] : []), _toConsumableArray(current >= total - 1 && total > 4 ? [{
    value: total - 3
  }] : []), _toConsumableArray(current === total && total > 4 ? [{
    value: current - 2
  }] : []), _toConsumableArray(current > 1 ? [{
    value: current - 1
  }] : []), [{
    value: current
  }], _toConsumableArray(current < total ? [{
    value: current + 1
  }] : []), _toConsumableArray(current === 1 && total > 4 ? [{
    value: current + 2
  }] : []), _toConsumableArray(current < 3 && total > 4 ? [{
    value: 4
  }] : []), _toConsumableArray(current <= total - 3 ? [{
    isDots: true,
    value: '...'
  }] : []), _toConsumableArray(current < total - 1 ? [{
    value: total
  }] : []));
};